import styles from "./CrearReporteDanios.module.css";
import { useContext, useState, useRef, useEffect } from "react";
import { AiOutlinePaperClip } from "react-icons/ai";
import Loading from "../../General/Loading";
import ConfirmMessage from "../../General/ConfirmMessage";
import { Paginacion } from "../../Commons/paginacion/Paginacion";
import { FiChevronDown } from "react-icons/fi";
import {
  Col,
  Row,
  Tabs,
  Tab,
  Container,
  Button,
  Modal,
  Form,
  InputGroup,
  FormControl,
  FormLabel,
  FormGroup,
  Card,
  Collapse,
} from "react-bootstrap";
import axios from "axios";

import ContextFlujos from "../../Context/ContextFlujos";
import {
  Attachment,
  EnviarEmail_Entrada,
  EnviarEmail_Parametros,
  Parametro,
  builtAttachment,
  builtEnviarEmail_Entrada,
  builtParametro,
} from "../../Commons/Services/EnviarEmail";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import flecha from "../../../src/assets/img/Iconos/flechaAbajo.svg";
import {
  DetalleSolicitudDeServicio,
  ConsultaSolicitudDeServicio_Respuesta,
  ConsultaSolicitudDeServicio_Parametros,
  builtRecargaConsultaPrecioRecargaInput,
  ConsultaSolicitudDeServicio_Entrada,
} from "../../Commons/Services/ConsultaSolicitudDeServicioRest";
import {
  builtSolicitudDeServicio,
  SolicitudDeServicio,
  builtContratacionServicios,
  ContratacionServicios,
  AltaSolicitudDeServicio_Entrada,
  builtAltaSolicitudDeServicio_Entrada,
  AltaSolicitudDeServicio_Parametros,
  AltaSolicitudDeServicio_Respuesta,
} from "../../Commons/Services/AltaSolicitudDeServicioRest";

const CrearReporteDanios = () => {
  let flagArray: boolean[] = [];
  const maxtLength = 100;
  const [file, setFile] = useState(null);
  const [fileName, setfileName] = useState("");
  const [file1, setFile1] = useState(null);
  const [fileName1, setfileName1] = useState("");
  const [show, setShow] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [motivo, setMotivo] = useState("");
  const [producto, setProducto] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [opcion, setOpcion] = useState("");
  const [cuenta, setCuenta] = useState(sessionStorage.getItem("cuenta"));
  const [cuentaSkyPlus, setCuentaSkyPlus] = useState(
    sessionStorage.getItem("cuentaSkyPlus")
  );
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [loading, isLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));
  const { setReportesHist } = useContext(ContextFlujos) as any;
  const [active, setActive] = useState("equipo");
  const [titleReportData, setTitleReportData] = useState("Acta de robo:");
  const [reportData, setReportData] = useState<any[]>([]);
  const [reportDataCard, setReportDataCard] = useState<any[]>([]);
  const [reportesPorPagina, setReportesPorPagina] = useState(5);
  const [paginaActualEquipo, setPaginaActualEquipo] = useState(1);
  const [paginaActualTI, setPaginaActualTI] = useState(1);
  const [flags, setFlag] = useState(flagArray);
  const [flag, refreshFlags] = useState(false);
  const handleShow = () => setShow(true);
  const [bloqueoSelect, setBloqueoSelect] = useState(false);
  const [verSelect, setVerSelect] = useState(false);
  const [verSelectInteligente, setVerSelectInteligente] = useState(true);
  const [portable, isPortable] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const inputRef1 = useRef<HTMLInputElement>(null);
  const [type, setType] = useState("equipo");
  const [fileExtesion, setFileExtesion] = useState("");
  const [fileExtesion1, setFileExtesion1] = useState("");

  let totalReportesEquipo = reportData.length;
  let totalReportesTI = reportDataCard.length;

  const ultimoIndiceEquipo = paginaActualEquipo * reportesPorPagina;
  const primerIndiceEquipo = ultimoIndiceEquipo - reportesPorPagina;
  const ultimoIndiceTI = paginaActualTI * reportesPorPagina;
  const primerIndiceTI = ultimoIndiceTI - reportesPorPagina;

  //const { REACT_APP_URL_OSB } = process.env;
  //let url_base = `${REACT_APP_URL_OSB}/EnterpriseServices/Sel/ConsultaSolicitudDeServicioRest`;
  //let url_base_save = `${REACT_APP_URL_OSB}/EnterpriseServices/Sel/AltaSolicitudDeServicioRest`;

  const handleFileButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileButtonClick1 = () => {
    if (inputRef1.current) {
      inputRef1.current.click();
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleClickCardsEquipo = (item: any) => {
    setReportData(
      reportData.map((e: any) =>
        e.id === item.id ? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
      )
    );
  };

  const handleClickCardsTI = (item: any) => {
    setReportDataCard(
      reportDataCard.map((e: any) =>
        e.id === item.id ? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
      )
    );
  };

  function handleClick(key: string) {
    setType(key);
    setActive(key);

    if (key == "equipo") {
      setVerSelect(false);
      getHistorialTeam();
    } else {
      setVerSelect(true);
      getHistorialCard();
    }
  }

  function formatDate(strDate: any) {
    if (strDate) {
      let dateTime = strDate.split(" ");
      return dateTime[0];
    }
  }
  function handleReporte(id: number) {
    flags[id] = !flags[id];
    setFlag(flags);
    refreshFlags(!flag);
  }

  //historial equipo
  async function getHistorialTeam() {
    isLoading(true);
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultaSolicitudDeServicioDO: ConsultaSolicitudDeServicio_Entrada =
      builtRecargaConsultaPrecioRecargaInput(
        `${sessionStorage.getItem("rowId")}`,
        "Tramites",
        "Seguro de Equipo"
      );
    let par = ConsultaSolicitudDeServicio_Parametros(
      ConsultaSolicitudDeServicioDO
    );

    let respuesta: ConsultaSolicitudDeServicio_Respuesta = await ConsultaWS(
      par
    );

    if (
      typeof respuesta.ConsultaSolicitudDeServicioProcessResponse
        .DetalleSolicitudDeServicio != "undefined"
    ) {
      if (
        respuesta.ConsultaSolicitudDeServicioProcessResponse
          .DetalleSolicitudDeServicio !== undefined
      ) {
        const res =
          respuesta.ConsultaSolicitudDeServicioProcessResponse
            .DetalleSolicitudDeServicio;
        const ar: object[] = [];

        if (res.length > 0) {
          res.forEach((element: object, i: number) => {
            if (i < 50) {
              ar.push(element);
            }
          });

          const temp = ar.map((e, i) => ({ ...e, id: i }));
          setReportData(temp.map((e) => ({ ...e, isOpen: false })));
        }

        totalReportesEquipo =
          respuesta.ConsultaSolicitudDeServicioProcessResponse
            .DetalleSolicitudDeServicio.length;
        //setReportData(response.data.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio);
        //añadir id e isopen
      }

      isLoading(false);
    } else {
      console.error(respuesta.ConsultaSolicitudDeServicioProcessResponse);
      isLoading(false);
    }
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  }

  //historial tarjeta
  async function getHistorialCard() {
    isLoading(true);

    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultaSolicitudDeServicioDO: ConsultaSolicitudDeServicio_Entrada =
      builtRecargaConsultaPrecioRecargaInput(
        `${sessionStorage.getItem("rowId")}`,
        "Tramites",
        "Tarjeta Inteligente"
      );
    let par = ConsultaSolicitudDeServicio_Parametros(
      ConsultaSolicitudDeServicioDO
    );

    let respuesta: ConsultaSolicitudDeServicio_Respuesta = await ConsultaWS(
      par
    );

    if (
      typeof respuesta.ConsultaSolicitudDeServicioProcessResponse
        .DetalleSolicitudDeServicio != "undefined"
    ) {
      if (
        respuesta.ConsultaSolicitudDeServicioProcessResponse
          .DetalleSolicitudDeServicio !== undefined
      ) {
        const res =
          respuesta.ConsultaSolicitudDeServicioProcessResponse
            .DetalleSolicitudDeServicio;
        const ar: object[] = [];

        if (res.length > 0) {
          res.forEach((element: object, i: number) => {
            if (i < 50) {
              ar.push(element);
            }
          });

          const temp = ar.map((e, i) => ({ ...e, id: i }));
          setReportDataCard(temp.map((e) => ({ ...e, isOpen: false })));
        }

        totalReportesTI =
          respuesta.ConsultaSolicitudDeServicioProcessResponse
            .DetalleSolicitudDeServicio.length;
        //setReportDataCard(response.data.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio);
      }

      isLoading(false);
    } else {
      console.error(respuesta.ConsultaSolicitudDeServicioProcessResponse);
      isLoading(false);
    }
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  }

  async function setReporte() {
    isLoading(true);
    const subarea =
      type == "equipo" ? "Seguro de Equipo" : "Tarjeta Inteligente";

    //----------------------------------------------------------------------------------------------------------------------------
    const ContratacionServiciosRet: ContratacionServicios =
      builtContratacionServicios(
        `${sessionStorage.getItem("Paquete")}`,
        "",
        "",
        "",
        "",
        ""
      );

    const SolicitudDeServicioRet: SolicitudDeServicio =
      builtSolicitudDeServicio(
        `${sessionStorage.getItem("cuenta")}`,
        "Tramites",
        subarea,
        subarea,
        "",
        `${sessionStorage.getItem("RowIdContacto")}`,
        `${sessionStorage.getItem("EmailNotif")}`, //l_MailConfirmacion: string,
        `${sessionStorage.getItem("pais")}`, //l_Pais: string,
        `${sessionStorage.getItem("TipoCuenta")}`, //l_TipoCuenta: string,
        `${sessionStorage.getItem("NombreSuscriptor")}`, //l_NombreSuscriptor: string,
        null,
        null,
        ContratacionServiciosRet,
        null,
        null,
        null,
        null,
        null,
        "HIJUMP",
        `${sessionStorage.getItem("idSesion")}`
      );
    const AltaSolicitudDeServicioDO: AltaSolicitudDeServicio_Entrada =
      builtAltaSolicitudDeServicio_Entrada(SolicitudDeServicioRet);
    let par = AltaSolicitudDeServicio_Parametros(AltaSolicitudDeServicioDO);
    let AltaSolicitudDeServicioRespuesta: AltaSolicitudDeServicio_Respuesta =
      await ConsultaWS(par);
    if (
      AltaSolicitudDeServicioRespuesta &&
      AltaSolicitudDeServicioRespuesta.resultado === "0" &&
      AltaSolicitudDeServicioRespuesta.resultadodesc === "0"
    ) {
      if (
        AltaSolicitudDeServicioRespuesta.NumeroSolicitud &&
        AltaSolicitudDeServicioRespuesta.NumeroSolicitud !== null &&
        typeof AltaSolicitudDeServicioRespuesta.NumeroSolicitud != "undefined"
      ) {
        const noSolicitud: string =
          AltaSolicitudDeServicioRespuesta.NumeroSolicitud;

        if (type === "equipo") {
          if (bloqueoSelect === false) {
            sendMail(
              noSolicitud,
              "Solicitud con 1 archivo(s) adjunto(s)",
              "SEGURO_EQUIPO_MX",
              true
            );
          } else {
            sendMail(
              noSolicitud,
              "Solicitud sin archivos adjuntos",
              "SEGURO_EQUIPO_MX",
              false
            );
          }
        } else {
          if (bloqueoSelect === false) {
            sendMail(
              noSolicitud,
              "Solicitud con 1 archivo(s) adjunto(s)",
              "SEGURO_TI_MX",
              true
            );
          } else {
            sendMail(
              noSolicitud,
              "Solicitud sin archivos adjuntos",
              "SEGURO_TI_MX",
              false
            );
          }
        }

        getHistorialTeam();
        getHistorialCard();

        setfileName("");
        setFileExtesion("");
        setFile(null);

        setfileName1("");
        setFileExtesion1("");
        setFile1(null);

        setStatus("OK");
        setMessage(
          "Reporte enviado con éxito, no. solicitud: " +
            AltaSolicitudDeServicioRespuesta.NumeroSolicitud
        );
        //setMessage("Reporte enviado con éxito." );
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }

      isLoading(false);
    } else {
      console.error(AltaSolicitudDeServicioRespuesta);
      setStatus("Error");
      setMessage("Error en el envío");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      isLoading(false);
    }

    //----------------------------------------------------------------------------------------------------------------------------
  }

  function sendMail(
    numeroSolicitud: string,
    adjuntos: string,
    codigo: string,
    banderaAdjuntos: boolean
  ) {
    file_to_base64(file1).then((result) => {
      const parametrosVar: Parametro[] = [
        builtParametro("NUMSS", `${numeroSolicitud}`),
        builtParametro("ADJUNTOS", `${adjuntos}`),
        builtParametro("CUENTA", `${sessionStorage.getItem("cuenta")}`),
        builtParametro(
          "NOMBRE_SUSCRIPTOR",
          `${sessionStorage.getItem("NombreSuscriptor")}`
        ),
      ];

      let attachmentVar: Attachment[] = [];

      if (banderaAdjuntos === true) {
        attachmentVar = [builtAttachment(fileName1, fileExtesion1, result)];
      }

      const EnviarEmailDO: EnviarEmail_Entrada = builtEnviarEmail_Entrada(
        "SEL",
        `${codigo}`,
        `${sessionStorage.getItem("EmailNotif")}`,
        `${sessionStorage.getItem("pais")}`,
        parametrosVar,
        attachmentVar
      );
      let par2 = EnviarEmail_Parametros(EnviarEmailDO);

      ConsultaWS(par2);

      setfileName("");
      setFileExtesion("");
      setFile(null);
      handleClose();
    });

    if (codigo === "SEGURO_TI_MX" && banderaAdjuntos === true) {
      file_to_base64(file).then((result) => {
        const parametrosVar: Parametro[] = [
          builtParametro("NUMSS", `${numeroSolicitud}`),
          builtParametro("ADJUNTOS", `${adjuntos}`),
          builtParametro("CUENTA", `${sessionStorage.getItem("cuenta")}`),
          builtParametro(
            "NOMBRE_SUSCRIPTOR",
            `${sessionStorage.getItem("NombreSuscriptor")}`
          ),
        ];

        const attachmentVar: Attachment[] = [
          builtAttachment(fileName, fileExtesion, result),
        ];

        const EnviarEmailDO: EnviarEmail_Entrada = builtEnviarEmail_Entrada(
          "SEL",
          `${numeroSolicitud}`,
          `${sessionStorage.getItem("EmailNotif")}`,
          `${sessionStorage.getItem("pais")}`,
          parametrosVar,
          attachmentVar
        );
        let par2 = EnviarEmail_Parametros(EnviarEmailDO);

        ConsultaWS(par2);

        setfileName("");
        setFileExtesion("");
        setFile(null);
        handleClose();
      });
    }
  }

  function handleChangeMotivoA(event: any) {
    switch (event.target.value) {
      case "Robo":
        setTitleReportData("Acta de robo:");
        break;
      case "Daño":
        setTitleReportData("Carta por daños:");
        break;
      case "Siniestro":
        setTitleReportData("Carta de hechos:");
        break;
    }
  }
  function disabledCheckA() {
    const checkboxOneInput = window.document.getElementById(
      "checkboxOneInput"
    ) as HTMLInputElement;
    if (checkboxOneInput !== null) {
      if (checkboxOneInput.checked) {
        setBloqueoSelect(true);
      } else {
        setBloqueoSelect(false);
      }
    }
  }

  const handleFileChange = (e: any) => {
    if (e.target) {
      if (e.target.files) {
        const files = e.target.files;
        if (files.length > 0) {
          const file = files[0];
          if (file.size > 1048576) {
            setStatus("Error");
            setMessage("El archivo elegido pesa mas de 1MB!");
            setShowAlert(true);
            setTimeout(() => {
              setShowAlert(false);
            }, 3000);

            // alert("El archivo elegido pesa mas de 1MB!");
          } else {
            setFile(file);
            setfileName(file.name);
            setFileExtesion(file.extension);
          }
        }
      }
    }
  };

  const handleFileChange1 = (e: any) => {
    if (e.target) {
      if (e.target.files) {
        const files = e.target.files;
        if (files.length > 0) {
          const file = files[0];
          if (file.size > 1048576) {
            setStatus("Error");
            setMessage("El archivo elegido pesa mas de 1MB!");
            setShowAlert(true);
            setTimeout(() => {
              setShowAlert(false);
            }, 3000);

            // alert("El archivo elegido pesa mas de 1MB!");
          } else {
            setFile1(file);
            setfileName1(file.name);
            setFileExtesion1(file.extension);
          }
        }
      }
    }
  };

  const file_to_base64 = async (a_file: any) => {
    let a_function = (file: any) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          let base64_string = String(reader.result).split(",")[1];
          resolve(base64_string);
        };
        reader.onerror = (error) => reject(error);
      });
    return (await a_function(a_file)) as string;
  };

  useEffect(() => {
    getHistorialTeam();
  }, []);

  return (
    <>
      <Loading isLoading={loading} />
      <Row className={styles["alertContainer"]}>
        <Col className={styles["messageStyle"]}>
          <ConfirmMessage
            status={status}
            message={message}
            showAlert={showAlert}
          />
        </Col>
      </Row>

      <Container className={styles.contenedor} fluid>
        <div id="bigUpper" className="d-none d-xl-block d-lg-block ">
          <Row className={styles["headerRow"]}>
            <Col>
              <p className={styles["titulo"]}>
                <span className={styles["spectrum"]}>
                  Reporte de robo, daño o extravío
                </span>
              </p>
              <p className={styles["subtitle"]}>
                Déjanos toda la información de tu reporte del servicio para
                poder resolverlo.
              </p>
            </Col>
          </Row>
        </div>
        <div id="smallUpper" className="d-lg-none d-xl-none">
          <Row className={styles["headerRowSmall1"]}>
            <Col>
              <p className={styles["titulo"]}>
                <span className={styles["spectrum"]}>
                  Reporte de robo, daño o
                </span>
              </p>
              <p className={styles["tituloInf"]}>
                <span className={styles["spectrum2"]}>extravío</span>
              </p>
              <p className={styles["subtitle"]}>
                Déjanos toda la información de tu reporte del servicio para
                poder resolverlo.
              </p>
            </Col>
          </Row>
        </div>
      </Container>

      <Container className={styles.contenedorInferior}>
        <Row>
          <Col className={styles["tabContainer"]}>
            <div id="big" className="d-none d-xl-block d-lg-block ">
              <Tabs
                id="createReporte"
                className={styles["divTabs"]}
                onSelect={(key) => handleClick(key!)}
                defaultActiveKey={""}
              >
                <Tab
                  tabClassName={
                    active === "equipo"
                      ? styles["divTabsActive"] + " " + styles["createReporte"]
                      : styles["createReporte"]
                  }
                  eventKey={"equipo"}
                  title={"Reporte sobre equipo"}
                  key={"equipo"}
                >
                  <Col className={styles["marginTab"]}>
                    <p className={styles["titleTab"]}>Seguro de equipo</p>
                    <ul className="unordered-list">
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por robo:</strong> Envíe el acta que se
                          levantó ante la autoridad competente. En caso de no
                          hacerlo deberá cubrir el costo del Receptor Dígital.
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>
                            Por siniestro (incendio, inundación, etc):
                          </strong>{" "}
                          Envié la carta de los hechos emitida por las
                          autoridades correspondientes.
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por daño:</strong> Envié la carta que explique
                          los hechos, si el daño no es imputable a SKY, deberá
                          cubrir el importe del deducible de equipo.
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Tab>
                <Tab
                  tabClassName={
                    active === "inteligente"
                      ? styles["divTabsActive"] + " " + styles["createReporte"]
                      : styles["createReporte"]
                  }
                  eventKey={"inteligente"}
                  title={"Reporte sobre nuestra tarjeta inteligente"}
                  key={"inteligente"}
                >
                  <Col className={styles["marginTab"]}>
                    <p className={styles["titleTab"]}>
                      Reposición de tarjeta inteligente
                    </p>
                    <ul className="unordered-list">
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por robo:</strong> Envíe copia del Acta ante
                          la autoridad competente y copia de la Identificación
                          del Títular..
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por daño:</strong> Envíe una carta donde se
                          explique lo ocurrido y que contenga la siguiente
                          leyenda: " Me hago responsable por el uso de la
                          Tarjeta Inteligente... " y copia de identificación del
                          Titular de la Cuenta..
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por extravío:</strong> Envíe una carta donde
                          se explique lo ocurrido y que contenga la siguiente
                          leyenda: " Me hago responsable por el uso de la
                          Tarjeta Inteligente... " y copia de identificación del
                          Titular de la Cuenta.
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Tab>
              </Tabs>
            </div>

            <div id="small" className="d-lg-none d-xl-none">
              <Tabs
                id="createReporte"
                className={styles["divTabs"]}
                onSelect={(key) => handleClick(key!)}
                defaultActiveKey={""}
              >
                <Tab
                  tabClassName={
                    active === "equipo"
                      ? styles["divTabsActive"] + " " + styles["createReporte"]
                      : styles["createReporte"]
                  }
                  eventKey={"equipo"}
                  title={"Equipo"}
                  key={"equipo"}
                >
                  <Col className={styles["marginTab"]}>
                    <p className={styles["titleTab"]}>Seguro de equipo</p>
                    <ul className="unordered-list">
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por robo:</strong> Envíe el acta que se
                          levantó ante la autoridad competente. En caso de no
                          hacerlo deberá cubrir el costo del Receptor Dígital.
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>
                            Por siniestro (incendio, inundación, etc):
                          </strong>{" "}
                          Envié la carta de los hechos emitida por las
                          autoridades correspondientes.
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por daño:</strong> Envié la carta que explique
                          los hechos, si el daño no es imputable a SKY, deberá
                          cubrir el importe del deducible de equipo.
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Tab>
                <Tab
                  tabClassName={
                    active === "inteligente"
                      ? styles["divTabsActive"] + " " + styles["createReporte"]
                      : styles["createReporte"]
                  }
                  eventKey={"inteligente"}
                  title={"Tarjeta inteligente"}
                  key={"inteligente"}
                >
                  <Col className={styles["marginTab"]}>
                    <p className={styles["titleTab"]}>
                      Reposición de tarjeta inteligente
                    </p>
                    <ul className="unordered-list">
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por robo:</strong> Envíe copia del Acta ante
                          la autoridad competente y copia de la Identificación
                          del Títular..
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por daño:</strong> Envíe una carta donde se
                          explique lo ocurrido y que contenga la siguiente
                          leyenda: " Me hago responsable por el uso de la
                          Tarjeta Inteligente... " y copia de identificación del
                          Titular de la Cuenta..
                        </p>
                      </li>
                      <li className={styles["optionList"] + " " + "list-item"}>
                        <p className={styles["subtitleTab"]}>
                          <strong>Por extravío:</strong> Envíe una carta donde
                          se explique lo ocurrido y que contenga la siguiente
                          leyenda: " Me hago responsable por el uso de la
                          Tarjeta Inteligente... " y copia de identificación del
                          Titular de la Cuenta.
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Tab>
              </Tabs>
            </div>

            <Row className={styles["mynewbgcolor"]}>
              <Col className={styles["colOpciones"]}>
                <p className={styles["subtitle"]}>
                  Otras opciones de envío de información:
                </p>
                <ul className="unordered-list">
                  <li className={styles["optionList"] + " " + "list-item"}>
                    <p className={styles["subtitleTab"]}>
                      <strong>Email:</strong> serviciosenlinea@sky.com.mx
                    </p>
                  </li>
                </ul>
                <p className={styles["subtitle1Mynewbgcolor"]}>
                  El formato de PNG no está soportado, se recomienda enviar
                  documentos en formato PDF que no superen 1 MB
                </p>
              </Col>
            </Row>
            <Row className={styles["subheaderRow"]}>
              <Col
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={4}
                className={styles["colSelect"]}
              >
                <p className={styles["textoSelect"]}>
                  <span className={styles.asterisco}>* </span>Motivo
                </p>
                <Form.Select
                  className={styles["select"]}
                  onChange={handleChangeMotivoA}
                >
                  <option value="Robo">Robo</option>
                  <option value="Daño">Daño</option>
                  <option value="Siniestro">Siniestro</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={4}>
                <p className={styles["textoSelect"]}>{titleReportData}</p>
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">
                    <AiOutlinePaperClip />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder={file1 ? fileName1 : "Adjuntar archivo"}
                    readOnly
                    aria-label="nameFile"
                    aria-describedby="basic-addon1"
                    value={file1 === null ? "" : fileName1}
                    disabled={bloqueoSelect}
                  />
                  <div className={styles["adjuntarContainer"]}>
                    <button
                      className={styles["btnAdjuntar"]}
                      onClick={handleFileButtonClick1}
                      disabled={bloqueoSelect}
                    >
                      {file1 ? "Actualizar" : "Adjuntar"}
                    </button>
                  </div>
                </InputGroup>
                <input
                  id="disputeFile1"
                  type="file"
                  ref={inputRef1}
                  onChange={handleFileChange1}
                  className={styles["hidden"]}
                />
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={4}
                style={{ display: verSelect ? "block" : "none" }}
              >
                <p className={styles["textoSelect"]}>
                  Identificación del titular
                </p>
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">
                    <AiOutlinePaperClip />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder={file ? fileName : "Adjuntar archivo"}
                    readOnly
                    aria-label="nameFile"
                    aria-describedby="basic-addon1"
                    value={file === null ? "" : fileName}
                    disabled={bloqueoSelect}
                  />
                  <div className={styles["adjuntarContainer"]}>
                    <button
                      className={styles["btnAdjuntar"]}
                      onClick={handleFileButtonClick}
                      disabled={bloqueoSelect}
                    >
                      {file ? "Actualizar" : "Adjuntar"}
                    </button>
                  </div>
                </InputGroup>
                <input
                  id="disputeFile"
                  type="file"
                  ref={inputRef}
                  onChange={handleFileChange}
                  className={styles["hidden"]}
                />
              </Col>
            </Row>
            <Row className={styles["subheaderRow"]}>
              <Col>
                <input
                  type="checkbox"
                  id="checkboxOneInput"
                  className="styleCheck"
                  onChange={disabledCheckA}
                />{" "}
                Prefiero no adjuntar los documentos en este momento
              </Col>
            </Row>
            <Row className={styles["subheaderRow"]}>
              <Col className={styles["aclararContainer"]}>
                <button
                  onClick={setReporte}
                  // disabled={file ? false : true}
                  className={styles["btnReportar"]}
                >
                  Reportar
                </button>
              </Col>
            </Row>
            <Row className={styles["rowHistorial"]}>
              <Col className={styles["marginTabHist"]}>
                <p className={styles["titleTab"]}>Tu historial de reportes</p>
              </Col>
            </Row>
            <Row className={styles["rowHistorial"]}>
              <Col>
                <div
                  id="bigGrid"
                  className={
                    "d-none d-sm-block d-md-block d-lg-block d-xl-block"
                  }
                >
                  <Container
                    fluid
                    className={
                      styles["subheaderRowGrid"] + " " + styles["historialGrid"]
                    }
                  >
                    {reportData !== undefined &&
                    reportData.length > 0 &&
                    type === "equipo" ? (
                      <Row
                        className={
                          styles["subheaderRowGrid"] +
                          " " +
                          styles["gridHeader"]
                        }
                      >
                        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                          <span>No. solicitud</span>
                        </Col>
                        <Col xs={3} sm={3} md={2} lg={3} xl={3}>
                          <span>Grupo</span>
                        </Col>
                        <Col xs={3} sm={3} md={4} lg={3} xl={3}>
                          <span>Tipo de orden</span>
                        </Col>
                        <Col xs={2} sm={3} md={3} lg={3} xl={3}>
                          <span>Fecha</span>
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}

                    {reportDataCard !== undefined &&
                    reportDataCard.length > 0 &&
                    type === "inteligente" ? (
                      <Row
                        className={
                          styles["subheaderRowGrid"] +
                          " " +
                          styles["gridHeader"]
                        }
                      >
                        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                          <span>No. solicitud</span>
                        </Col>
                        <Col xs={3} sm={3} md={2} lg={3} xl={3}>
                          <span>Grupo</span>
                        </Col>
                        <Col xs={3} sm={3} md={4} lg={3} xl={3}>
                          <span>Tipo de orden</span>
                        </Col>
                        <Col xs={2} sm={3} md={3} lg={3} xl={3}>
                          <span>Fecha</span>
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}

                    {reportData !== undefined && type === "equipo" ? (
                      reportData
                        .map((data, index) => (
                          <>
                            <Row
                              className={
                                styles["subheaderRowGrid"] +
                                " " +
                                styles["grid"]
                              }
                              key={"bigRow_" + index}
                            >
                              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                <span>{data.NumeroDeSolicitud}</span>
                              </Col>
                              <Col xs={3} sm={3} md={2} lg={3} xl={3}>
                                <span>{data.Area}</span>
                              </Col>
                              <Col xs={3} sm={3} md={4} lg={3} xl={3}>
                                <span>{data.SubAarea}</span>
                              </Col>
                              <Col xs={2} sm={3} md={3} lg={3} xl={3}>
                                <span>{formatDate(data.FechaCreacion)}</span>
                              </Col>
                            </Row>
                          </>
                        ))
                        .slice(primerIndiceEquipo, ultimoIndiceEquipo)
                    ) : (
                      <></>
                    )}

                    {reportDataCard !== undefined && type === "inteligente" ? (
                      reportDataCard
                        .map((data, index) => (
                          <>
                            <Row
                              className={
                                styles["subheaderRowGrid"] +
                                " " +
                                styles["grid"]
                              }
                              key={"bigRow_" + index}
                            >
                              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                <span>{data.NumeroDeSolicitud}</span>
                              </Col>
                              <Col xs={3} sm={3} md={2} lg={3} xl={3}>
                                <span>{data.Area}</span>
                              </Col>
                              <Col xs={3} sm={3} md={4} lg={3} xl={3}>
                                <span>{data.SubAarea}</span>
                              </Col>
                              <Col xs={2} sm={3} md={3} lg={3} xl={3}>
                                <span>{formatDate(data.FechaCreacion)}</span>
                              </Col>
                            </Row>
                          </>
                        ))
                        .slice(primerIndiceTI, ultimoIndiceTI)
                    ) : (
                      <></>
                    )}
                  </Container>
                </div>

                {/**Seccion para responsivo */}

                <div
                  id="smallGrid"
                  className={"d-sm-none d-md-none d-lg-none d-xl-none"}
                >
                  <Container className={styles["contenedorSmall"]}>
                    {reportData !== undefined && type === "equipo" ? (
                      reportData
                        .map((data: any) => (
                          <Card style={{ marginBottom: "3vw" }}>
                            <Row>
                              <Col className={styles["headerCard"]}>
                                <p className={styles["navegaSmall"]}>
                                  <b>{data.NumeroDeSolicitud}</b>
                                </p>
                              </Col>
                              <Col>
                                <span>
                                  <Button
                                    style={{
                                      background: "white",
                                      border: "none",
                                      float: "right",
                                    }}
                                    onClick={() => handleClickCardsEquipo(data)}
                                  >
                                    <img
                                      src={flecha}
                                      aria-controls="example-collapse-text"
                                      aria-expanded={data.isOpen}
                                      className={
                                        data.isOpen === true
                                          ? styles["rota"]
                                          : styles["noRota"]
                                      }
                                    />
                                  </Button>
                                </span>
                              </Col>
                            </Row>
                            <Collapse in={data.isOpen}>
                              <div
                                id="example-collapse-text"
                                className={styles["infoCardSmall"]}
                              >
                                <p className={styles["subtituloInfo"]}>
                                  <b>No. de solicitud</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.NumeroDeSolicitud}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Grupo</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.Area}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Tipo de orden</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.SubAarea}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Fecha</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {formatDate(data.FechaCreacion)}
                                </p>
                              </div>
                            </Collapse>
                          </Card>
                        ))
                        .slice(primerIndiceEquipo, ultimoIndiceEquipo)
                    ) : (
                      <></>
                    )}

                    {reportDataCard !== undefined && type === "inteligente" ? (
                      reportDataCard
                        .map((data: any) => (
                          <Card style={{ marginBottom: "3vw" }}>
                            <Row>
                              <Col className={styles["headerCard"]}>
                                <p className={styles["navegaSmall"]}>
                                  <b>{data.NumeroDeSolicitud}</b>
                                </p>
                              </Col>
                              <Col>
                                <span>
                                  <Button
                                    style={{
                                      background: "white",
                                      border: "none",
                                      float: "right",
                                    }}
                                    onClick={() => handleClickCardsTI(data)}
                                  >
                                    <img
                                      src={flecha}
                                      aria-controls="example-collapse-text"
                                      aria-expanded={data.isOpen}
                                      className={
                                        data.isOpen === true
                                          ? styles["rota"]
                                          : styles["noRota"]
                                      }
                                    />
                                  </Button>
                                </span>
                              </Col>
                            </Row>
                            <Collapse in={data.isOpen}>
                              <div
                                id="example-collapse-text"
                                className={styles["infoCardSmall"]}
                              >
                                <p className={styles["subtituloInfo"]}>
                                  <b>No. de solicitud</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.NumeroDeSolicitud}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Grupo</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.Area}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Tipo de orden</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {data.SubAarea}
                                </p>
                                <p className={styles["subtituloInfo"]}>
                                  <b>Fecha</b>
                                </p>
                                <p className={styles["infoCollapse"]}>
                                  {formatDate(data.FechaCreacion)}
                                </p>
                              </div>
                            </Collapse>
                          </Card>
                        ))
                        .slice(primerIndiceTI, ultimoIndiceTI)
                    ) : (
                      <></>
                    )}
                  </Container>
                </div>

                <Container
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "100px",
                  }}
                >
                  {type === "equipo" &&
                  reportData !== undefined &&
                  reportData.length > 0 ? (
                    <Paginacion
                      itemsPorPagina={reportesPorPagina}
                      pageActual={paginaActualEquipo}
                      setPageActual={setPaginaActualEquipo}
                      itemsTotal={totalReportesEquipo}
                    />
                  ) : (
                    <></>
                  )}
                  {type === "inteligente" &&
                  reportDataCard !== undefined &&
                  reportDataCard.length > 0 ? (
                    <Paginacion
                      itemsPorPagina={reportesPorPagina}
                      pageActual={paginaActualTI}
                      setPageActual={setPaginaActualTI}
                      itemsTotal={totalReportesTI}
                    />
                  ) : (
                    <></>
                  )}

                  <div>
                    {reportData.length === 0 && type === "equipo" ? (
                      <>
                        <h4 className={styles["tituloAviso"]}>
                          Parece que aún no has hecho ningún reporte
                        </h4>
                        <p className={styles["textoAviso"]}>
                          Cuando realices un reporte podrás visualizarlo aquí
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                    {reportDataCard.length === 0 && type === "inteligente" ? (
                      <>
                        <h4 className={styles["tituloAviso"]}>
                          Parece que aún no has hecho ningún reporte
                        </h4>
                        <p className={styles["textoAviso"]}>
                          Cuando realices un reporte podrás visualizarlo aquí
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CrearReporteDanios;
